import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Select, Spin, Empty } from 'antd';
import { debounce } from 'lodash';

const InfiniteScrollSelect = ({
    value,
    onChange,
    labelKey = 'label',
    valueKey = 'value',
    data = [],
    renderOption,
    placeholder = 'Select...',
    mode = undefined,
    allowClear = true,
    disabled = false,
    style = {},
    className = '',
    dropdownStyle = {},
    onClear,
    tagRender = {},
    getPopupContainer,
    fetchMore = () => { },
    isNext = false,
    onSearch = () => { },
    loading = false,
    currentPage = 1,
    reset = () => { },
    onOpen = () => { },
}) => {
    const [options, setOptions] = useState(data);
    const [searchText, setSearchText] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (isDropdownOpen) {
            setOptions(data);
        }
    }, [data, isDropdownOpen]);

    const debouncedSearch = useCallback(
        debounce((val) => {
            onSearch(val);
            // fetchMore(1, val);
        }, 400),
        []
    );

    const handleSearch = (val) => {
        setSearchText(val);
        debouncedSearch(val);
    };

    const handleScroll = (e) => {
        dropdownRef.current = e.target;
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        const atBottom = scrollTop + clientHeight >= scrollHeight - 10;

        if (atBottom && isNext && !loading) {
            fetchMore(currentPage + 1, searchText); // ✅ use current typed value
        }
    };

    const handleDropdownVisibleChange = (open) => {
        setIsDropdownOpen(open);
        if (open) {
            onOpen();
        } else {
            reset();
            setSearchText('');
            setOptions([]);
            setTimeout(() => {
                if (dropdownRef.current) {
                    dropdownRef.current.scrollTo({ top: 0 });
                    dropdownRef.current.style.overflowY = 'auto';
                    dropdownRef.current.style.overflowX = 'hidden';
                }
            }, 50);
        }
    };

    return (
        <Select
            labelInValue
            value={value}
            onChange={onChange}
            mode={mode}
            placeholder={placeholder}
            allowClear={allowClear}
            disabled={disabled}
            style={{ width: '250px', ...style }}
            className={className}
            tagRender={tagRender}
            dropdownStyle={dropdownStyle}
            getPopupContainer={getPopupContainer}
            onClear={onClear}
            showSearch
            onSearch={handleSearch} // ✅ debounced + update
            filterOption={false}
            onPopupScroll={handleScroll}
            onDropdownVisibleChange={handleDropdownVisibleChange}
            notFoundContent={loading ? <Spin size="small" /> : <Empty />}
        >
            {options.map((item) => (
                <Select.Option key={item[valueKey]} value={item[valueKey]}>
                    {renderOption ? renderOption(item) : item[labelKey]}
                </Select.Option>
            ))}
        </Select>
    );
};

export default InfiniteScrollSelect;
